<template>
	<div id="Orders" class="orders">
		<vue-snotify></vue-snotify>
		<div v-if="tabSelected == 'List'">
			<nav class="navbar navbar-light bg-light">
				<div class="form-inline">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromOrders" @change="getAllOrdersLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToOrders" @change="getAllOrdersLocal(1)">
					<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchOrders"
						v-model="searchOrders"
						v-on:keyup.enter="getAllOrdersLocal(1)"
						@focus="$event.target.select()">
					<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getAllOrdersLocal(1)">Buscar</button>
					<div class="float-right d-none d-sm-inline separator"></div>
					<button class="btn btn-sm btn-outline-primary my-2 my-sm-1 margin-right5" title="Nuevo pedido" @click="changeTab('New', 0)">
						<i class="fas fa-plus"></i>
					</button>
				</div>
				<div class="form-inline">
					<span class="mr-sm-1">Mostrar</span>
					<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsOrder" @change="changeQRowsOrder">
						<option>5</option>
						<option>10</option>
						<option>25</option>
						<option>50</option>
						<option>100</option>
						<option>200</option>
						<option>1000</option>
					</select>
				</div>
			</nav>		

			<div v-if="!searchingOrder">
				<table class="table table-sm table-12">
					<thead>
						<tr>
							<th>ID</th>
							<th>Cliente</th>
							<th>Total</th>
							<th>Estado</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listOrders" :key="index">
							<td>{{ item.id }}</td>
							<td>{{ item.client }}</td>
							<td>{{ item.total }}</td>
							<td>{{ item.status }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-else>
				<div class="jumbotron text-center">
					<h1 class="display-7">
						Buscando pedidos . . .
						<img src="@/assets/search-color.gif" width="100px"/>
					</h1>
				</div>
			</div>
		</div>
		<div v-if="tabSelected == 'New'">
			<order-denominational-form-component
				ref="orderDenominationalFormComponent"
				:id="idSelected"
				:orderWeb="orderWeb"
				@actionCloseComponenet="tabSelected='List'"
				@actionSaveOrder="saveOrderResultLocal"
				@actionJumpSellerOrders="getJumpSellerOrdersLocal(1)">
			</order-denominational-form-component>
		</div>

		<button data-toggle="modal" data-target="#orderModal" ref="btnShowOrderModalLocal"></button>
		<div class="modal fade" id="orderModal" aria-labelledby="orderModalLabel" aria-hidden="true" tabindex="-1">
			<div class="modal-dialog" :class="sizeOrderModal">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="orderModalLabel">
							Order de Pedido - 
							<span v-if="idSelected == 0" class="badge badge-primary">
								Nuevo
							</span>
							<span v-else>
								Nº {{ idSelected }}
							</span>
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="btnCloseOrderModal" ref="btnCloseOrderModal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<order-denominational-form-component
							ref="orderDenominationalFormComponent"
							:id="idSelected"
							:orderWeb="orderWeb"
							@actionSaveOrder="saveOrderResultLocal"
							@actionJumpSellerOrders="getJumpSellerOrdersLocal(1)">
						</order-denominational-form-component>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import order from '@/mixins/orders'

import OrderDenominationalFormComponent from '@/components/OrderDenominationalFormComponent.vue'

export default {
	name: 'Orders',
	mixins: [axiosAction, errors, mixin, order],
	data() {
		return {
			idSelected: 0,
			sizeOrderModal: 'modal-xl',
			orderWeb: null,
			tabSelected: 'New'
		}
	},
	components: {
		'order-denominational-form-component': OrderDenominationalFormComponent,
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Ordenes de Pedido')
			this.setSubTitleModule('')
			this.setOrderInit()
		},
		btnCloseOrderModal() {
			this.$refs.orderDenominationalFormComponent.$refs.btnClearOrderLocal.click()
		},
		changeQRowsOrderLocal() {},
		getAllOrdersLocal(page) {
			this.getAllOrdersDenominational(page)
		},
		getAllOrdersResultLocal(response) {
		},
		getJumpSellerOrdersLocal(page) {
			this.orderWeb = null
			this.$refs.btnCloseOrderModal.click()
			this.$refs.btnShowJumpSellerOrdersModal.click()
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllOrdersResult': this.getAllOrdersResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		saveOrderResultLocal(data) {
			this.$refs.btnCloseOrderModal.click()
		},
		setSizeOrderModal(class_) {
			this.sizeOrderModal = class_
		},
		changeTab(tab, id = 0) {
			this.tabSelected = tab
			this.orderWeb = null
			this.idSelected = id
			this.$refs.orderDenominationalFormComponent.$refs.btnClearOrderLocal.click()
		},
		showOrderModalLocal(id) {
			this.orderWeb = null
			this.idSelected = id
			this.$refs.orderDenominationalFormComponent.$refs.btnClearOrderLocal.click()
			this.$refs.btnShowOrderModalLocal.click()
		},
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>